webpackJsonp([139202632470071],{

/***/ 156:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(156);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fp = __webpack_require__(11);
	
	var _util = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var authorJson = _ref.authorJson,
	      showAboutTheAuthor = _ref.showAboutTheAuthor;
	
	  var headShot = (0, _fp.get)('image.fields.file.url', authorJson);
	  authorJson = authorJson || {};
	  return _react2.default.createElement(
	    'div',
	    { className: 'author-metadata', itemProp: 'author', itemScope: true, itemType: 'http://schema.org/Person' },
	    (0, _util.renderIf)(headShot, _react2.default.createElement('img', { itemProp: 'image', className: 'author-image', src: headShot, alt: authorJson.name })),
	    (0, _util.renderIf)(!headShot, _react2.default.createElement(
	      'h2',
	      { itemProp: 'name', style: headShot ? {} : { marginBottom: '1em', fontSize: '3em' }, className: 'author-name' },
	      ' ',
	      authorJson.name,
	      ' '
	    )),
	    _react2.default.createElement(
	      'div',
	      { className: 'author-name-container' },
	      (0, _util.renderIf)(headShot, _react2.default.createElement(
	        'h2',
	        { itemProp: 'name', className: 'author-name' },
	        ' ',
	        authorJson.name,
	        ' '
	      )),
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'author-sharebtn-container',
	          style: {
	            width: authorJson.twitter && authorJson.website ? '100px' : '50px',
	            right: authorJson.twitter && authorJson.website ? '-125px' : '-75px'
	          } },
	        (0, _util.renderIf)(authorJson.twitter, _react2.default.createElement('a', { itemProp: 'url', className: 'author-twitter', href: 'https://www.twitter.com/' + authorJson.twitter })),
	        (0, _util.renderIf)(authorJson.website, _react2.default.createElement('a', { itemProp: 'url', className: 'author-website', href: authorJson.website })),
	        (0, _util.renderIf)(authorJson.linkedIn, _react2.default.createElement('a', { itemProp: 'url', className: 'author-linkedin', href: authorJson.linkedIn }))
	      )
	    ),
	    (0, _util.renderIf)(authorJson.biography, _react2.default.createElement(
	      'p',
	      { itemProp: 'description', className: 'author-biography' },
	      authorJson.biography
	    ))
	  );
	};
	//<div style={{paddingTop: '2em'}}>
	//<hr style={{borderTop: '2px solid #e7e9ee'}}/>
	//{renderIf(showAboutTheAuthor, <h3 className='about-the-author'>About the Author</h3>)}
	//</div>
	

	module.exports = exports['default'];

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fp = __webpack_require__(11);
	
	var _dateFns = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	exports.default = function (_ref) {
	  var blogPost = _ref.blogPost;
	
	  var imageSrc = (0, _fp.get)('imageHeader.fields.file.url', blogPost);
	  var imageAlt = (0, _fp.get)('image.fields.description', blogPost);
	  var authorName = (0, _fp.get)('blogAuthor.fields.name', blogPost);
	  var authorSlug = '/' + (0, _fp.get)('blogAuthor.fields.slug', blogPost);
	  return _react2.default.createElement(
	    'div',
	    { itemID: '/' + blogPost.slug, itemScope: true, itemType: 'http://schema.org/LiveBlogPosting', className: 'LegacyPost stub' },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: '400px', overflow: 'hidden' }, className: 'blog-subheader' },
	      _react2.default.createElement('img', { itemProp: 'image', style: { width: '100%' }, src: imageSrc, alt: imageAlt })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container blog-content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'col-md-8 col-md-offset-2 blog_content' },
	        _react2.default.createElement(
	          'h2',
	          { itemProp: 'headline' },
	          blogPost.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'author_name' },
	          'By ',
	          _react2.default.createElement(
	            'a',
	            { itemScope: true, itemProp: 'Person', itemType: 'http://schema.org/Person', href: authorSlug },
	            _react2.default.createElement(
	              'span',
	              { itemProp: 'name' },
	              authorName
	            )
	          ),
	          ' on ',
	          _react2.default.createElement(
	            'span',
	            { itemProp: 'datePublished', content: blogPost.createdAt },
	            (0, _dateFns.format)(blogPost.createdAt, 'MMMM D, YYYY')
	          )
	        ),
	        _react2.default.createElement('p', { itemProp: 'description', className: 'intro', dangerouslySetInnerHTML: { __html: blogPost.intro } }),
	        _react2.default.createElement('link', { itemProp: 'sameAs', href: '/' + blogPost.slug }),
	        _react2.default.createElement(
	          'a',
	          { className: 'btn btn-primary', href: '/' + blogPost.slug },
	          'READ MORE'
	        )
	      )
	    )
	  );
	}; // LIBS
	

	module.exports = exports['default'];

/***/ }),

/***/ 1963:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	__webpack_require__(1963);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dateFns = __webpack_require__(17);
	
	var _fp = __webpack_require__(11);
	
	var _util = __webpack_require__(12);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	var _blogPostItem = __webpack_require__(56);
	
	var _blogPostItem2 = _interopRequireDefault(_blogPostItem);
	
	var _authorMetadata = __webpack_require__(114);
	
	var _authorMetadata2 = _interopRequireDefault(_authorMetadata);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	
	
	// HELPERS
	// STYLE
	var query = exports.query = '** extracted graphql fragment **';
	
	// COMPONTENTS
	
	
	// LIBS
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var blogPosts = (0, _fp.sortBy)(function (item) {
	    return new Date(item.createdAt);
	  }, (0, _fp.map)((0, _fp.get)('node'), (0, _fp.get)('allBlogJson.edges', data)));
	  var authorJson = data.authorJson;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'blog-author' },
	    _react2.default.createElement(_metaData2.default, { data: authorJson }),
	    _react2.default.createElement(_authorMetadata2.default, { authorJson: authorJson }),
	    _react2.default.createElement(
	      'div',
	      { className: 'blog-author-posts' },
	      blogPosts.reverse().map(function (node, i) {
	        return _react2.default.createElement(_blogPostItem2.default, { key: i, blogPost: node });
	      })
	    ),
	    _react2.default.createElement('span', { className: 'clearfix' })
	  );
	};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-author-index-js-a1267fe818a678af1e85.js